import {
    TOGGLE_KEYBOARD_NAVIGATION,
    SET_FOOTER_PROPS,
    RESET_FOOTER_PROPS,
    SELECTION_MODE
} from "../constants/global.constant";

export const configureKeyboardNavigation = (enable) => ({
    type: TOGGLE_KEYBOARD_NAVIGATION,
    payload: enable,
});

// Export enum for use in components (state lives in Zustand canvasStore)
export { SELECTION_MODE };

// FooterBar configuration actions
export const setFooterBarProps = (props) => ({
    type: SET_FOOTER_PROPS,
    payload: props
});

export const resetFooterBarProps = () => ({
    type: RESET_FOOTER_PROPS
});
